// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WFYuKXegxbozZuHDbBeI{display:grid;grid-template-columns:1fr 1fr;gap:8px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/Schedule/ui/MonthDaysSelector/ui/OnTheContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,6BAAA,CACA,OAAA","sourcesContent":[".wrap{\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `WFYuKXegxbozZuHDbBeI`
};
export default ___CSS_LOADER_EXPORT___;
